import Vue from 'vue';
import Router from 'vue-router';
import ElilHome from './../components/ElilHome';
import ElilScoreBoard from './../components/ElilScoreBoard';
import ElilAlwaysLion from './../components/ElilAlwaysLion';
import ElilImprint from './../components/ElilImprint';
import ElilNotFound from './../components/ElilNotFound';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Da Loewe',
      component: ElilHome,
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: ElilImprint,
    },
    {
      path: '/tabelle',
      name: 'Die aktuell Tabelle',
      component: ElilScoreBoard,
    },
    {
      path: '/immer-loewe',
      name: 'Einmal Löwe, immer Löwe',
      component: ElilAlwaysLion,
    },
    {
      path: '*',
      component: ElilNotFound,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js